import React from 'react';

import App from '../pages/App';
import NotFound from "../pages/NotFound";
import Home from '../pages/Home';
import SyntaxHighlighting from '../pages/SyntaxHighlighting';
import CheckScss from '../pages/CheckScss';
export interface RouteConfig {
  Component: React.FC;
  path: string | null;
  routes?: RouteConfig[];
}

export const routeConfig: RouteConfig[] = [
  {
    path: '/',
    Component: App,
    routes: [
      {
        path: null, // index path
        Component: Home,
      },
      {
        path: '*',
        Component: NotFound,
      },
      {
        path: '/syntax-highlighting',
        Component: SyntaxHighlighting,
      },
      {
        path: '/check-scss',
        Component: CheckScss,
      },
    ]
  }
];
